module.exports = __webpack_public_path__ + "static/img_20-17fe6e94463a0bd658a30e31db597e2f.png";